import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { CircleMarker, CircleMarkerProps } from 'react-leaflet';
import { ISegmentationPolygonProps } from '../SegmentationLayerFeatures';

interface IProps {
  isActive: boolean;
  tooltip?: ReactElement;
}

export const PointFeature = observer((props: ISegmentationPolygonProps & CircleMarkerProps & IProps): ReactElement => {
  const handleRef = (element: CircleMarker<ISegmentationPolygonProps & CircleMarkerProps>): void => {
    if (props.isActive && element && 'enableEdit' in element.leafletElement && typeof element.leafletElement.enableEdit === 'function') {
      element.leafletElement.enableEdit();
    }
  };

  const { tooltip, ...rest } = props;

  return (
    <CircleMarker<ISegmentationPolygonProps & CircleMarkerProps>
      {...rest}
      ref={handleRef}
    >
      {tooltip}
    </CircleMarker>
  );
});
